<template>
  <div class="profile-card border-left border-right">
    <div class="weui-panel weui-panel_access" v-if="account.id">
      <div class="weui-panel__bd" @click="editProfile">
        <div class="weui-media-box weui-media-box_appmsg">
          <div class="weui-media-box__bd">
            <p v-if="!isWxWork" class="card-title" @click.stop="switchCompany">
              {{company.name}}<i class="iconfont icon-right"></i>
            </p>
            <p v-else class="card-title">
              {{company.name}}
            </p>
            <h4 class="weui-media-box__title">{{account.realname}}</h4>
            <ul class="weui-media-box__info">
              <li
                class="weui-media-box__info__meta"
                v-for="(role,xindex) in roles"
                :key="role.id"
                :class="{'weui-media-box__info__meta_extra':xindex>0}"
              >{{role.name}}</li>
            </ul>
          </div>
          <div class="weui-media-box__ft">
            <img class="weui-media-box__thumb" :src="avatarUrl" alt />
          </div>
        </div>
      </div>
      <div class="weui-panel__ft" @click="shareCompany">
        <a href="javascript:" class="weui-cell">
          <div class="weui-cell__bd list-item-muted">企业二维码</div>
          <span class="weui-cell__ft">
            <a class="weui-btn_reset weui-btn_icon">
              <i class="iconfont icon-qrcode js_category_icon"></i>
            </a>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import Auth from "@/util/auth.js";
import Weixin from "@/util/weixin.js";

export default {
  data() {
    let isWxWork = Weixin.isWxWork()
    return {
      company: {},
      account: {},
      roles: [],
      isWxWork
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    avatarUrl() {
      return this.account.avatarUrl || require("../assets/images/user.png");
    }
  },
  methods: {
    loadData() {
      var me = this;
      Auth.get()
        .then(function(data) {
          var account = data.account;
          me.company = account.defaultCompany;
          me.account = account;
          if (account.rolesMap) {
            me.roles = account.rolesMap[account.companyId];
          }
        })
        .catch(function(res) {
          me.$router.push({
            name: "Error",
            params: res
          });
        });
    },
    editProfile() {
      this.$router.push("/sys/account_edit");
    },
    shareCompany() {
      this.$router.push("/sys/company_card");
    },
    switchCompany() {
      this.$router.push("/switch_company")
    }
  }
};
</script>

<style>
.profile-card {
  margin: 15px !important;
  border-radius: 4px;
}
.profile-card .card-title {
  color: var(--weui-FG-1);
  margin-bottom: 16px;
}
.profile-card .weui-media-box__info {
  margin-top: 5px;
}
.profile-card .weui-panel__ft .weui-cell {
  padding: 4px 16px;
}
.profile-card .weui-panel__ft .weui-cell:first-child::before {
  display: block;
  left: 0;
}
.profile-card .weui-media-box_appmsg .weui-media-box__ft {
  margin-left: 16px;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.profile-card .list-item-muted {
  font-size: 16px;
}
.profile-card .js_category_icon {
  font-size: 24px;
}
</style>